import { queryOptions, useQuery } from '@tanstack/react-query';

import { draftOrdersApi } from '../api/draft-orders-api';

import { draftOrderKeys } from './draft-order-keys';

export function draftPaymentOptionsQueryOptions(storeId: string) {
  return queryOptions({
    queryKey: draftOrderKeys.paymentOptions(storeId),
    queryFn: () => draftOrdersApi.paymentOptions(storeId),
  });
}

export function useDraftPaymentOptions(storeId: string, enabled = true) {
  return useQuery({ ...draftPaymentOptionsQueryOptions(storeId), enabled });
}
